module.exports = __webpack_public_path__ + "static/img/s01.8f13f8c8.png";